import React, {useEffect, useRef, useState} from 'react';
import {webInfo} from "../../../utils/webInfo";
import {FileUpload} from "primereact/fileupload";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Card} from "primereact/card";
import useApi from "../../../hooks/useApi";
import usePost from "../../../hooks/usePost";
import {Button} from "primereact/button";
import {InputTextarea} from "primereact/inputtextarea";
import callToast, {catchError, showErrors} from "../../../utils/helper";
import {Calendar} from "primereact/calendar";
import moment from "moment/moment";
import {Skeleton} from "primereact/skeleton";
import {Toast} from "primereact/toast";
import TextEditor from "../../../components/TextEditor";
import {InputSwitch} from "primereact/inputswitch";

const NewsroomCreate = () => {
    const toast = useRef<any>(null);
    const [blog, setBlog] = useState<any>({
        summary: "",
        image: "",
        category_id: "",
        author: "",
        description: "",
        title: "",
        meta_title: "",
        meta_description: "",
        meta_keywords: "",
        meta_image: "",
        meta_robots: "",
        meta_author: "",
        is_active:false,
    })
    const categoryUrl = `${webInfo.baseUrl}/api/admin/news-events-categories?page=1&per_page=200`
    const url = `${webInfo.baseUrl}/api/admin/news-events`
    const {get, loading} = useApi<any>();
    const {post} = usePost()
    const [category, setCategory] = useState<any>([])
    const [dates, setDates] = useState<any>({
        published_at: new Date(),
        event_date: new Date(),
    })

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await get(categoryUrl);
                const options = res.data.map((item: any) => {
                    return {
                        name: item.name,
                        code: item.id,
                    }
                })
                setCategory(options);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchCategories();
        // eslint-disable-next-line
    }, []);

    const onUpload = (event: any) => {
        setBlog({
            ...blog,
            image: event.files[0],
        })
    };

    const onRemove = () => {
        setBlog({
            ...blog,
            image: ""
        })
    };

    const onMetaUpload = (event: any) => {
        setBlog({
            ...blog,
            meta_image: event.files[0],
        })
    };

    const onMetaRemove = () => {
        setBlog({
            ...blog,
            meta_image: ""
        })
    };

    const handleChange = (e: any) => {
        setBlog({
            ...blog,
            [e.target.name]: e.target.value,
        })
    }

    // const addBlog = async () => {
    //
    //     const formData = new FormData();
    //     const payload: any = {
    //         ...blog,
    //     }
    //     for (const key in payload) {
    //         const value = payload[key as keyof typeof payload];
    //         if (value !== null && value.length > 0) {
    //             if (key === "image" && typeof value === "string") continue;
    //             if (key === "meta_image") continue;
    //             formData.append(key, payload[key]);
    //         }
    //     }
    //     if (dates.event_date){
    //         const eventDate = moment(dates.event_date).format("YYYY-MM-DD")
    //         formData.append('event_date', eventDate);
    //     }
    //     if (dates.published_at){
    //         const formatedData = moment(dates.published_at).format("YYYY-MM-DD")
    //         formData.append('published_at', formatedData);
    //     }
    //
    //     try {
    //         // @ts-ignore
    //         const res: any = await post(url, false, formData);
    //         if (res.success){
    //             callToast(toast,true,res.data.message)
    //         }else {
    //             showErrors(res.error.message || res.error,toast);
    //         }
    //     } catch (e) {
    //         catchError(e)
    //     }
    // }
    const addBlog = async () => {
        const formData = new FormData();

        const payload: any = {
            ...blog,
        };

        for (const key in payload) {
            const value = payload[key as keyof typeof payload];

            if (value === null || value === undefined) continue;

            // send 1 / 0 for laravel boolean field
            if (key === "is_active") {
                formData.append("is_active", blog?.is_active ? "1" : "0");
                continue;
            }

            // skip empty strings
            if (typeof value === "string" && value.trim().length === 0) continue;

            // skip existing image url
            if (key === "image" && typeof value === "string") continue;
            if (key === "meta_image" && typeof value === "string") continue;

            // handle file upload
            if (key === "image" && value instanceof File) {
                formData.append("image", value);
                continue;
            }

            if (key === "meta_image" && value instanceof File) {
                formData.append("meta_image", value);
                continue;
            }

            formData.append(key, String(value));
        }

        if (dates.event_date) {
            const eventDate = moment(dates.event_date).format("YYYY-MM-DD");
            formData.append("event_date", eventDate);
        }

        if (dates.published_at) {
            const formatedData = moment(dates.published_at).format("YYYY-MM-DD");
            formData.append("published_at", formatedData);
        }


        try {
            // @ts-ignore
            const res: any = await post(url, false, formData);

            if (res.success) {
                callToast(toast, true, res.data.message);
            } else {
                showErrors(res.error.message || res.error, toast);
            }
        } catch (e) {
            catchError(e);
        }
    };

    const content = <div>
        <div className="grid">
            <div className="col-12 md:col-7">
                <div className="pr-2">
                    <div className="my-2">
                        <label className="font-medium">Title *</label>
                        <InputText name={'title'} value={blog?.title} className="w-full" onChange={handleChange}
                                   placeholder="Title"/>
                    </div>
                    <div className="p-fluid grid my-2">
                        <div className="col-12 md:col-6">
                            <label className="font-medium">Author *</label>
                            <InputText name={'author'} value={blog?.author} className="w-full" onChange={handleChange}
                                       placeholder="Author"/>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="font-medium">Category *</label>
                            <Dropdown
                                value={category?.find((item: any) => Number(item?.code) === Number(blog?.category_id))}
                                onChange={(e) => {
                                    setBlog({
                                        ...blog,
                                        category_id: e.value.code,
                                    })
                                }} options={category}
                                optionLabel="name"
                                placeholder="Select a Category" className="w-full"/>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="font-medium">Published Date</label>
                            <Calendar value={dates.published_at} name={'published_at'} onChange={(e: any) => {
                                setDates({
                                    ...dates,
                                    [e.target.name]: e.value
                                })
                            }} placeholder={'Published at'}/>
                        </div>
                        <div className="col-12 md:col-6">
                            <label className="font-medium">Event Date</label>
                            <Calendar value={dates.event_date} onChange={(e: any) => {
                                setDates({
                                    ...dates,
                                    [e.target.name]: e.value
                                })
                            }} name={'event_date'} placeholder={'Event date'}/>
                        </div>
                    </div>
                    <div>
                        <label className="font-medium">Summary *</label>
                        <InputTextarea placeholder={'Summary'} name={'summary'} value={blog.summary}
                                       className='w-full' onChange={handleChange} style={{height: '100px'}}/>
                    </div>
                    <div>
                        <label className="font-medium">Details *</label>
                        {/*<TinyEditor*/}
                        {/*    value={blog.description}*/}
                        {/*    onChange={(description: string) =>*/}
                        {/*        setBlog((prev: any) => ({...prev, description}))*/}
                        {/*    }*/}
                        {/*/>*/}
                        <TextEditor
                            value={blog.description || ''}
                            setValue={(content: string) =>
                                setBlog((prev: any) => ({
                                    ...prev,
                                    description: content,
                                }))
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 md:col-5">
                <div className="pl-2">
                    <div className="col-12">
                        <label className="font-medium">Thumbnail Image (600 × 315 || 1024 kB max) *</label>
                        <FileUpload
                            name="demo[]"
                            url="/api/upload"
                            multiple={false}
                            accept="image/*"
                            maxFileSize={1024 * 1024}
                            onSelect={onUpload}
                            onRemove={onRemove}
                        />

                    </div>
                </div>

                <div className="grid p-4">
                    <div className="col-12">
                        <h4 className="mb-3">SEO Information</h4>
                    </div>

                    {/* Meta Title */}
                    <div className="col-12">
                        <label className="font-medium">Meta Title</label>
                        <InputText
                            name="meta_title"
                            value={blog.meta_title || ""}
                            onChange={handleChange}
                            placeholder="Meta Title"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Author */}
                    <div className="col-12 md:col-6">
                        <label className="font-medium">Meta Author</label>
                        <InputText
                            name="meta_author"
                            value={blog.meta_author || ""}
                            onChange={handleChange}
                            placeholder="Meta Author"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Robots */}
                    <div className="col-12 md:col-6">
                        <label className="font-medium">Meta Robots</label>
                        <Dropdown
                            value={blog.meta_robots || ""}
                            options={[
                                {label: "Index, Follow", value: "index, follow"},
                                {label: "No Index, Follow", value: "noindex, follow"},
                                {label: "Index, No Follow", value: "index, nofollow"},
                                {label: "No Index, No Follow", value: "noindex, nofollow"}
                            ]}
                            onChange={(e) =>
                                setBlog({...blog, meta_robots: e.value})
                            }
                            placeholder="Select Robots Option"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Description */}
                    <div className="col-12">
                        <label className="font-medium">Meta Description</label>
                        <InputTextarea
                            name="meta_description"
                            value={blog.meta_description || ""}
                            onChange={handleChange}
                            rows={4}
                            placeholder="Meta Description"
                            className="w-full"
                            autoResize
                        />
                    </div>

                    {/* Meta Keywords */}
                    <div className="col-12">
                        <label className="font-medium">Meta Keywords</label>
                        <InputText
                            name="meta_keywords"
                            value={blog.meta_keywords || ""}
                            onChange={handleChange}
                            placeholder="keyword1, keyword2, keyword3"
                            className="w-full"
                        />
                    </div>

                    {/* Meta Image Upload */}
                    <div className="col-12">
                        <label className="font-medium">Meta Image (600 × 315 || 1024 kB max)</label>
                        <FileUpload
                            name="demo[]"
                            url="/api/upload"
                            multiple={false}
                            accept="image/*"
                            maxFileSize={1024 * 1024}
                            onSelect={onMetaUpload}
                            onRemove={onMetaRemove}
                        />
                    </div>
                </div>
            </div>
        </div>
        <div className="col-12 flex justify-content-end gap-2 mt-3">
            <Button onClick={addBlog} label="Create News" icon="pi pi-check"/>
        </div>
    </div>

    const loader = <div className="grid">
        <div className="col-12 md:col-7">
            <div className="pr-2"><Skeleton className="w-full" height="60rem"></Skeleton></div>
        </div>
        <div className="col-12 md:col-5">
            <div className="pl-2"><Skeleton className="w-full" height="60rem"></Skeleton></div>
        </div>
    </div>

    const header = (
        <div className="flex align-items-center justify-content-between p-4 pb-0">
            <h4 className="m-0">New News</h4>
            <div className="flex align-items-center">
                <label htmlFor="">Publish Now</label>
                <InputSwitch className="ml-2" name={'is_active'} checked={blog.is_active} onChange={handleChange} />
            </div>
        </div>
    )
    return (
        <Card header={header}>
            <Toast ref={toast}/>
            {loading ? loader : content}
        </Card>
    );
};


export default NewsroomCreate;